'use client';

import { useTranslations } from 'next-intl';

type VeradigmUnlockInstructionsProps = {
  isVisible: boolean;
  onToggle: () => void;
};

export const VeradigmUnlockInstructions = ({
  isVisible,
  onToggle,
}: VeradigmUnlockInstructionsProps) => {
  const t = useTranslations('sso.veradigm.error');

  return (
    <div className="w-full text-left">
      <div className="flex justify-center">
        <button
          className="inline-flex items-center gap-2 text-sm font-medium text-blue-600 hover:text-blue-700"
          onClick={onToggle}
          type="button"
        >
          {isVisible
            ? t('unlockInstructionsToggleHide')
            : t('unlockInstructionsToggleShow')}
        </button>
      </div>

      {isVisible ? (
        <div className="mt-3 rounded-md border border-slate-200 bg-slate-50 p-4 text-sm text-slate-700">
          <p className="font-semibold text-slate-900">
            {t('unlockInstructionsTitle')}
          </p>
          <p className="mt-2 text-slate-700">
            {t('unlockInstructionsSummary')}
          </p>
          <ul className="mt-3 list-disc space-y-2 pl-5 text-slate-700">
            <li>{t('unlockInstructionsContactItems')}</li>
            <li>{t('unlockInstructionsSummaryItem')}</li>
          </ul>
        </div>
      ) : null}
    </div>
  );
};
